import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { filter, map, startWith, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Directive({
    selector: '[appAddCurrencyPrefix]',
    standalone: true
})
export class AddCurrencyPrefixDirective implements OnDestroy, OnInit {
  private currencyMap = {
    GBP: '£',
    USD: '$',
    CAD: '$',
    AUD: '$',
    EUR: '€'
  };

  @Input() set appAddCurrencyPrefix(value: string) {
    this.overRideCurrency = value;
    this.addCurrencyPrefix(value);
  }

  private overRideCurrency: string;

  defaultCurrency = this.configService.userConfig.pipe(
    filter((config) => !!config && !!config.currency),
    map((config) => config.currency)
  );
  private destroy$ = new Subject<void>();

  constructor(
    private configService: ConfigService,
    private el: ElementRef
  ) {}

  ngOnInit() {
    this.defaultCurrency
      .pipe(takeUntil(this.destroy$), startWith('GBP'))
      .subscribe((config) => {
        if (!this.overRideCurrency) {
          this.addCurrencyPrefix(config);
        }
      });
  }

  private addCurrencyPrefix(currency: string) {
    if (!currency || !this.currencyMap[currency]) {
      return;
    }
    const { nativeElement } = this.el;
    nativeElement.classList.add('text-lg');
    const currencySymbol = this.currencyMap[currency];
    nativeElement.innerHTML = `&nbsp;${currencySymbol}&nbsp;`;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
